import * as React from "react";
import { forwardRef } from "react";
const SvgIcConfirmedBold20 = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M8.13497 15L15.531 2.52921L12.9676 0.970703L6.6914 11.5996L2.5532 7.51327L0.445312 9.64794L5.86533 15H8.13497Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgIcConfirmedBold20);
export { ForwardRef as ReactComponent };
